import { h, render } from 'preact';
import Website from './Website';

export default class App {

  public bootstrap() {
    const main = document.getElementsByTagName('body')[0];
    main.innerHTML = '';
    render(<Website />, main);
  }

}


// WEBPACK FOOTER //
// ./ts/App.tsx